import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractApiService } from '@shared/abstracts/abstract-api.service';
import { DailyProgressDto } from '@shared/dto';
import { urlJoin } from '@shared/utils/url.utils';

/**
 * Analytics endpoints that are not owned by the clinical-diary UI in member.
 * Member-scoped clinical metrics stay on MemberAnalyticsService.
 */
@Injectable({ providedIn: 'root' })
export class AnalyticsService extends AbstractApiService {
  get endpoint(): string | null {
    return `${this.api$.value}/:memberId/analytics`;
  }

  constructor() {
    super();
    this.api$.next(urlJoin(this.env.get('api.base'), 'members'));
  }

  getDailyProgress(memberId: number): Observable<DailyProgressDto> {
    return this.http.get<DailyProgressDto>(
      `${this.url({ memberId })}/daily-progress`,
    );
  }
}
